module.exports = __webpack_public_path__ + "./images/22a950c1059aea14ddd90b4cbf38a40f.webp";